import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'
import dictionaryManage from '@/views/dictionaryManage.vue'

Vue.use(VueRouter)

// 解决重复导航报错（如已在 /login 再跳转 /login）
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => {
    if (!err) return Promise.reject(err)
    const msg = err.message || ''
    // 忽略重复导航和被新导航取消的错误，避免控制台出现红色错误日志
    if (
      err.name === 'NavigationDuplicated' ||
      err.name === 'NavigationCancelled' ||
      msg.indexOf('Avoided redundant navigation') !== -1 ||
      /cancelled/i.test(msg)
    ) {
      return Promise.resolve(this.currentRoute)
    }
    return Promise.reject(err)
  })
}

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue'),
    meta: { title: '注册' }
  },
  {
    path: '/home',
    component: () => import('@/layouts/MainLayout.vue'),
    redirect: '/home',
    meta: { requiresAuth: true },
    children: [
      {
        path: '/home',
        name: 'UserManagement',
        component: () => import('@/views/UserManagement.vue'),
        meta: { title: '用户管理' }
      },
      {
        path: '/products',
        name: 'ProductManagement',
        component: () => import('@/views/ProductManage.vue'),
        meta: { title: '产品管理' }
      },
        {
            path: '/swiper',
            name: 'HomeSwiperManage',
            component: () => import('@/views/HomeSwiperManage.vue'),
            meta: { title: '轮播图管理' }
        },
        {
            path: '/liveBroadcast',
            name: 'liveBroadcast',
            component: () => import('@/views/liveBroadcastManage.vue'),
            meta: { title: '直播管理' }
        },
        {
            path: '/dictionary',
            name: 'dictionary',
            component: dictionaryManage
        },
      {
        path: '/specifications',
        name: 'SpecificationManage',
        component: () => import('@/views/SpecificationManage.vue'),
        meta: { title: '规格管理' }
      },
      {
        path: '/wechatQr',
        name: 'WechatQrManage',
        component: () => import('@/views/WechatQrManage.vue'),
        meta: { title: '微信群二维码管理' }
      },
      {
        path: '/reviewVideos',
        name: 'ReviewVideoManage',
        component: () => import('@/views/ReviewVideoManage.vue'),
        meta: { title: '测评视频管理' }
      }
      ,
      {
        path: '/guides',
        name: 'GuideManage',
        component: () => import('@/views/GuideManage.vue'),
        meta: { title: '攻略管理' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = getToken()

  // 白名单：不需要登录的页面
  const whiteList = ['/login', '/register']

  // 如果已登录
  if (token) {
    // 如果访问登录或注册页面，重定向到 home
    if (whiteList.includes(to.path)) {
      next('/home')
    } else {
      // 访问其他页面，检查是否需要认证
      if (to.meta.requiresAuth) {
        next()
      } else {
        // 如果不需要认证，也允许访问
        next()
      }
    }
  } else {
    // 如果未登录
    if (whiteList.includes(to.path)) {
      // 访问登录或注册页面，允许访问
      next()
    } else {
      // 访问需要认证的页面，重定向到登录页
      if (to.meta.requiresAuth) {
        next('/login')
      } else {
        // 其他页面（如根路径），也重定向到登录页
        next('/login')
      }
    }
  }
})

export default router
